/**
 * handleFilterTranslatedToConfig - Filters SelectOption arrays by ProductConfig values
 *
 * Extracted from client ProductForm.tsx (lines 188-196)
 * Filters translated select options to only include values that are present
 * in the product configuration. Special handling for regionAndCountry which
 * returns all options unfiltered.
 *
 * @param selectOptions - Array of select options to filter
 * @param key - ProductConfig key to check against
 * @param productConfig - Product configuration object
 * @returns Filtered array of SelectOption
 */

import type { ProductConfig, SelectOption } from "@shared/types/product";

export type { ProductConfig, SelectOption };

export function handleFilterTranslatedToConfig(
  selectOptions: SelectOption[],
  key: keyof ProductConfig,
  productConfig: ProductConfig
): SelectOption[] {
  if (key === "regionAndCountry") return selectOptions;

  const validConfigValues = productConfig[key];
  if (!Array.isArray(validConfigValues) || validConfigValues.length === 0) {
    return selectOptions;
  }

  return selectOptions.filter((option) => validConfigValues.includes(option.value));
}
